export const en = {
    'iframe-title': 'Yandex.Ether player',
};
